import { api } from "../services/api";
import { useApiData } from "../hooks/useApiData";
import { useSession } from "../context/SessionContext";
import { DataState } from "../components/Feedback";
import PageHeader from "../components/PageHeader";
import SectionCard from "../components/SectionCard";
import DataTable from "../components/DataTable";
import StatusChip from "../components/StatusChip";
import { POLICY } from "../constants";
import { formatDate } from "../utils/format";

export default function PoliciesPage() {
  const { clientId } = useSession();
  const state = useApiData(() => api.getPolicies(), [clientId]);

  const columns = [
    { key: "title", label: "Policy", render: (p) => <strong>{p.title}</strong> },
    { key: "version", label: "Version" },
    { key: "owner", label: "Owner" },
    { key: "status", label: "Status", render: (p) => <StatusChip label={p.statusLabel} color={POLICY[p.status].color} /> },
    { key: "lastReviewed", label: "Last reviewed", render: (p) => formatDate(p.lastReviewed) },
    {
      key: "nextReviewDue", label: "Next review",
      render: (p) =>
        p.reviewOverdue
          ? <StatusChip label={`Overdue · ${formatDate(p.nextReviewDue)}`} color="#EF4444" />
          : formatDate(p.nextReviewDue),
    },
  ];

  return (
    <>
      <PageHeader title="Policies" subtitle="The documents that set the rules, and when each is due for review." />
      <DataState state={state}>
        {(rows) => (
          <SectionCard>
            <DataTable columns={columns} rows={rows} emptyText="No policies yet." />
          </SectionCard>
        )}
      </DataState>
    </>
  );
}
